export default __webpack_public_path__ + "static/media/imacImg.1dc7d444.png";